import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=69c1807d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=69c1807d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c1807d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c1807d')) {
      api.createRecord('69c1807d', component.options)
    } else {
      api.reload('69c1807d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=69c1807d&scoped=true&", function () {
      api.rerender('69c1807d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PyppVq2E3p5j/JS/comp/GuestBox.vue"
export default component.exports